<script setup lang="ts">
import { resolveBrandConfig } from "@dashboard/brands/brandConfig";
import { formatCopyrightYears } from "@dashboard/utils/formatCopyrightYears";

interface Props {
  copyrightYearFrom?: string;
  copyrightExtraText?: string;
}

defineOptions({ inheritAttrs: false });
const props = defineProps<Props>();
const config = resolveBrandConfig("vodafone");
const links = config.footerLinks;

function copyrightValue(): string {
  const yearFrom = props.copyrightYearFrom ?? config.copyrightYearFrom;
  const extraText = props.copyrightExtraText ?? config.copyrightExtraText;
  return `© ${formatCopyrightYears(yearFrom)} ${extraText}`;
}
</script>

<template>
  <footer class="rc-layout">
    <div class="rc-layout-inner">
      <div class="flex wrapper-footer-links">
        <ul class="flex row footer-links">
          <template v-for="link in links" :key="link.className">
            <li>
              <a
                :class="[link.className, `CId-link-${link.className}`, `IId-link-${link.className}`]"
                :href="link.href"
                target="_blank"
                rel="noopener"
              >{{ link.label }}</a>
            </li>
            <li v-if="link.className === 'legal'">
              <!-- OneTrust's delegated handler owns this button, including after remounts. -->
              <button
                id="ot-preference-trigger"
                type="button"
                class="preferences CId-link-preferences IId-link-preferences"
                data-dtm-element="button"
              >Cookie preferences</button>
            </li>
          </template>
        </ul>
      </div>
      <p id="copyright">{{ copyrightValue() }}</p>
    </div>
  </footer>
</template>
